import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import VueRouter from 'vue-router'

import 'buefy/dist/buefy.css'

Vue.use(Buefy)
Vue.config.productionTip = false
Vue.use(VueRouter)

import Landing from './components/Landing.vue'
import Page from './components/Page.vue'
import Posts from './components/Posts.vue'
import Post from './components/Post.vue'
import Bureau from './components/Bureau.vue'
import Congres from './components/Congres.vue'

const router = new VueRouter({
    mode: 'history',
    routes: [
        // PageHome will be rendered inside Page's <router-view>
        { path: '/', component: Landing, name: 'landing' },
        { path: '/page/bureau', component: Bureau, props: { singlepage: true } },
        { path: '/page/congres', component: Congres, props: { singlepage: true } },
        { path: '/page/:id', component: Page },
        { path: '/post/:id', component: Post },
        { path: '/actualites', component: Posts },
        { path: '*', redirect: '/page/not-found' }
    ],
    scrollBehavior: function(to) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
})

var moment = require('moment')
// filters
Vue.filter('formatTimestamp', function(value) {
    if (value) {
        return moment.unix(value).format("DD/MM/YYYY")
    }
})
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value, 'YYYY-MM-DD').format("DD/MM/YYYY")
    }
})
Vue.filter('capitalize', function(value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})


Vue.prototype.$api_url_base = process.env.VUE_APP_APIPURI
Vue.prototype.$api_key = process.env.VUE_APP_APIKEY
Vue.prototype.$api_url_posts = Vue.prototype.$api_url_base + '/api/collections/get/post?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_pages = Vue.prototype.$api_url_base + '/api/collections/get/page?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_contact = Vue.prototype.$api_url_base + '/api/forms/submit/contact?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_countdown = Vue.prototype.$api_url_base + '/api/singletons/get/Countdown?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_referents = Vue.prototype.$api_url_base + '/api/singletons/get/referents?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_bureau = Vue.prototype.$api_url_base + '/api/collections/get/bureau?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_congres = Vue.prototype.$api_url_base + '/api/collections/get/congres?token=' + Vue.prototype.$api_key


Vue.prototype.$share_hashtag = 'AEMP'

// global mixin
Vue.mixin({
    // update paths from API
    updated: function() {
        var curloc = window.location.origin
        // liens vers pages
        const links = this.$el.querySelectorAll("a[href^='collection://']")
        links.forEach((link) => {
            link.href = link.href.replace('collection://', "/");
            link.onclick = function() { location.href = link.href; };
        });
        // liens fichiers
        const links2 = this.$el.querySelectorAll("a[href^='/storage']")
        links2.forEach((link) => {
            var newhref = link.href.replace(curloc, '')
            newhref = this.$api_url_base + newhref
            link.href = newhref
            link.target = '_blank'
        });
        // liens images
        const imgs = this.$el.querySelectorAll("img[src^='/storage']")
        imgs.forEach((img) => {
            var newsrc = img.src.replace(curloc, '')
            newsrc = this.$api_url_base + newsrc
            img.src = newsrc
        });
        var meladdr = this.$el.querySelector("#meladdr")
        if (meladdr && meladdr.innerHTML == '') {
            var str = "moc.liamg@yspmea"
            meladdr.innerHTML = str.split("").reverse().join("");
        }
    },
})

new Vue({
    render: h => h(App),
    router: router,
}).$mount('#app')